import {
    RaikoButtonPrimary,
    RaikoGridOneColumn,
    showErrorMessage, showSuccessMessage,
    showWarningMessage,
    RaikoMultiSelectTable,
    RaikoFlexAlignEnd,
    RaikoSectionContainer,
    RaikoGridThreeColumn,
    RaikoMaterialOutlinedInput,
    RaikoNumberInputOutlined
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {AccountService} from "../../../serverService/account/AccountService";
import {UserService} from "../../../serverService/userService/UserService";
import {useAuthState} from "../../../context/AuthContext";
import {useDebounce} from "@uidotdev/usehooks";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import {preparationRowsUsersTable, usersTableHeader} from "../../users/Users";
import {css} from "@emotion/css";
import {useParams} from "react-router-dom";

export default function AccountChooseGuardian(
    {
        selectedGuardian = [],
        changeGuardianInfo,
        accountInfo
    }
) {

    const service = new AccountService()
    const usersService = new UserService()

    const {fundID} = useAuthState()
    const {id: accountId} = useParams()


    let page = 0
    const size = 15


    const [users, setUsers] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [selectedItems, setSelectedItems] = useState(selectedGuardian);

    const [fullName, setFullName] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [groupName, setGroupName] = useState("")
    const filterFullName = useDebounce(fullName, 300)
    const filterNationalCode = useDebounce(nationalCode, 300)
    const filterGroupName = useDebounce(groupName, 300)

    useEffect(() => {
        getDataFromServer();

    }, [filterFullName,
        filterNationalCode,
        filterGroupName]);

    function getDataFromServer() {
        setTableLoading(true)

        usersService.getUsersList(
            page,
            size,
            fundID,
            filterFullName,
            filterGroupName,
            filterNationalCode
        ).then(response => {

            setPageCount(response.totalPage)
            setUsers([])
            response.data.map((item, index) => {
                if (parseInt(item.id) !== parseInt(accountId))
                    setUsers(prevState => [
                        ...prevState,
                        {
                            ...preparationRowsUsersTable(
                                item.id,
                                (page * size) + index + 1,
                                item.firstName && item.lastName ? `${item.firstName} ${item.lastName}` : "-",
                                item.nationalCode,
                                item.groupName,
                                item.phoneNumber,
                                item.enabled
                            ),
                            // name: item.firstName && item.lastName ? `${item.firstName} ${item.lastName}` : "-"
                        }
                    ])
            })

        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    const [actionButtonLoading, setActionButtonLoading] = useState(false)

    function handleUpdateGuardian() {

        if (selectedItems && selectedItems.length > 0) {
            setActionButtonLoading(true)
            service.updateAccountDetail(
                fundID,
                accountId,
                accountInfo.number,
                accountInfo.openedAt,
                accountInfo.enabled,
                selectedItems[0].id
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                changeGuardianInfo(response)
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                setActionButtonLoading(false)
            })
        } else
            showWarningMessage("لطفا ابتدا یک عضو را انتخاب نمایید.")
    }


    return (
        <RaikoGridOneColumn
            className={css`
              padding: 0 1rem 1rem 1rem;
              position: relative`}>
            <RaikoSectionContainer
            title={"جستجو"}>
            <RaikoGridThreeColumn>
                <RaikoMaterialOutlinedInput
                    labelText={"نام و نام خانوادگی"}
                    value={fullName}
                    setValue={setFullName}/>
                <RaikoNumberInputOutlined
                    labelText={"کد ملی"}
                    value={nationalCode}
                    setValue={setNationalCode}/>
                <RaikoMaterialOutlinedInput
                    labelText={"نام گروه"}
                    value={groupName}
                    setValue={setGroupName}/>
            </RaikoGridThreeColumn>

        </RaikoSectionContainer>
            <RaikoMultiSelectTable
                pageCount={pageCount}
                handleChangePagination={handleChangePagination}
                tableData={users}
                tableHeader={header}
                setSelectedItems={setSelectedItems}
                selectedItems={selectedItems}
                selectedItemsTitle={"قیم انتخاب شده برای حساب"}
                notSelectedAnyItemAlertTitle={"قیم مورد نظر خود را انتخاب نمایید."}
                notSelectedAnyItemAlertDescription={[]}
                isSingleSelect
                tableLoadingState={tableLoading}
            />
            <div
                className={css`
                  position: sticky;
                  bottom: 0;
                  background: var(--color-on-surface);
                  padding: 1rem 0;
                `}>
                <RaikoFlexAlignEnd>
                    <RaikoButtonPrimary
                        label={"ثبت قیم"}
                        onClick={handleUpdateGuardian}
                        loading={actionButtonLoading}
                    />
                </RaikoFlexAlignEnd>
            </div>
        </RaikoGridOneColumn>
    )
}
const header = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "fullName",
        label: "نام و نام خانوادگی"
    },
    {
        id: "nationalCode",
        label: "کد ملی",
    },
    {
        id: "groupName",
        label: "نام گروه",
    },
    {
        id: "phoneNumber",
        label: "شماره همراه"
    },
    {
        id: "enabled",
        label: "وضعیت"
    },
]

